import { PeoplePicker, PersonType } from "@microsoft/mgt-react";
import { FormControl, FormHelperText, FormLabel } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useRef, useState } from "react";
import { Controller } from "react-hook-form";
import style from "./Input.module.css";

const FormInputMSPerson = ({
  name,
  label,
  control,
  rules,
  error,
  allowMultiple,
  onChange = () => void 0,
}) => {
  const [people, setPeople] = useState([]);

  return (
    <Box className={style.control}>
      <FormControl fullWidth size="small" error={error !== undefined}>
        <FormLabel>{label}</FormLabel>
        <Controller
          name={name}
          control={control}
          rules={rules}
          render={({ field }) => {
            return (
              <InnerInputMSPerson
                name={name}
                value={field.value}
                peopleChanged={(newPeople) => {
                  field.onChange(newPeople);
                  setPeople(newPeople);
                  onChange();
                }}
                allowMultiple={allowMultiple}
                error={error}
              />
            );
          }}
        />
        <FormHelperText>{error}</FormHelperText>
      </FormControl>
    </Box>
  );
};

export default FormInputMSPerson;

const InnerInputMSPerson = ({
  name,
  value,
  peopleChanged,
  allowMultiple,
  error,
}) => {
  const [show, setShow] = useState(false);
  const [innerPeople, setInnerPeople] = useState(value);

  const ppRef = useRef();

  const handleSelectionChanged = (e) => {
    //when the people in the people picker change send up the values to the parent control
    peopleChanged(
      e.detail.map((p) => {
        if (p?.mail) return p.mail;
        else return p?.scoredEmailAddresses[0]?.address;
      })
    );
  };

  useEffect(() => {
    //using this timeout and comparing the current value with the previous value
    //we can set the people in the people picker to update to what is passed in
    if (JSON.stringify(value) !== JSON.stringify(innerPeople)) {
      setShow(false);
      setTimeout(() => {
        setInnerPeople(value);
        setShow(true);
      }, 10);
    } else setShow(true);
  }, [value]);

  return (
    <>
      {show && (
        <>
          <PeoplePicker
            id={name}
            type={PersonType.any}
            ref={ppRef}
            selectionChanged={handleSelectionChanged}
            groupId="db63fa55-c95c-4e58-a2ae-3c597523201b" //this group is sd36-staff
            defaultSelectedUserIds={value}
            selectionMode={allowMultiple ? "multiple" : "single"}
            showMax={6}
            placeholder="Start typing a name..."
            userType="user"
            className={
              error === undefined ? style.peoplePicker : style.peoplePickerError
            }
          />
        </>
      )}
    </>
  );
};
